import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { environment, FeaturesSettings } from "../../../environments/environment";
import { ApiService } from "../../admin/api.service";
import { EnvConfigService } from "../../env-config.service";
import { FirebasemessagingService } from "../../firebasemessaging.service";

@Component({
  selector: "ngx-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  isdownload = FeaturesSettings.isdownload;
  isDemoMode = FeaturesSettings.isDemoMode;
  demoEmail = FeaturesSettings.demoEmail;
  demoPassword = FeaturesSettings.demoPassword;
  baseurl = environment.BASEURL;

  loginMode: 'admin' | 'fleet' = 'admin';

  loginStatus: any;
  loginStatusMessage: any;
  fleetLoginStatus: any;
  fleetLoginStatusMessage: any;

  loginForm = this.fb.group({
    email: [
      this.demoEmail,
      [Validators.required, Validators.pattern("[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,3}$")],
    ],
    password: [this.demoPassword, [Validators.required]],
  });

  fleetLoginForm = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required]],
  });

  getConfigValue: any;
  showMessages: any;
  errors: any;
  submitted: any;
  messages: any;
  user: any;
  rememberMe: any;
  socialLinks: any;
  form: any;
  activeTab: any = 'driver';
  item: any;
  envData = this.envservice.getEnvData();
  riderQrImg: any;
  driverQrImg: any;
  link = "productLinks";
  fcmId: any;

  constructor(
    public fb: FormBuilder,
    private readonly _service: ApiService,
    private readonly http: HttpClient,
    private readonly router: Router,
    private readonly envservice: EnvConfigService,
    private readonly firebasemessaging: FirebasemessagingService
  ) {}

  ngOnInit(): void {
    this.getLink();
    this.getconfigFile();
    this.firebasemessaging.requestPermission();
    this.firebasemessaging.getFcmToken().subscribe((res) => {
      this.fcmId = res;
    });
  }

  setLoginMode(mode: 'admin' | 'fleet') {
    this.loginMode = mode;
    this.loginStatus = null;
    this.loginStatusMessage = null;
    this.fleetLoginStatus = null;
    this.fleetLoginStatusMessage = null;
  }

  login() {
    if (this.loginForm.valid) {
      const payload = {
        email: this.loginForm.value.email,
        password: this.loginForm.value.password,
      };
      this._service.CommonLoginPostApi(payload, "common/login/admin").subscribe({
        next: (res) => {
          if (res.type == "success") {
            localStorage.setItem("AdminDetails", JSON.stringify(res.data.admin));
            localStorage.setItem("token", res.data.token);
            this.loginStatus = res.type;
            this.loginStatusMessage = res.message;
            this.envservice.loadConfig().subscribe(() => {
              this.envservice.isInstallation$.subscribe((isInstalled) => {
                if (isInstalled) {
                  this.router.navigate(["/admin/dashboard"]);
                } else {
                  this.router.navigate(["/installation"]);
                }
              });
            });
          }
        },
        error: (error) => {
          this.loginStatus = error.error.type;
          this.loginStatusMessage = error.error.message;
        },
      });
    }
  }

  fleetLogin() {
    if (this.fleetLoginForm.valid) {
      const payload = {
        email: this.fleetLoginForm.value.email,
        password: this.fleetLoginForm.value.password,
      };
      this.http.post(environment.API_ENDPOINT + 'module/fleet/auth/login', payload).subscribe({
        next: (res: any) => {
          if (res.type === 'success') {
            localStorage.setItem('fleet_token', res.data.token);
            localStorage.setItem('FleetOperatorDetails', JSON.stringify(res.data.fleetOperator));
            this.fleetLoginStatus = 'success';
            this.fleetLoginStatusMessage = res.message;
            this.router.navigate(['/fleet-operator/dashboard']);
          }
        },
        error: (error) => {
          this.fleetLoginStatus = 'error';
          this.fleetLoginStatusMessage = error.error?.message || 'Login failed.';
        },
      });
    }
  }

  getconfigFile() {
    this.riderQrImg = this.envData.app.qrRiderImage
      ? this.baseurl + this.envData.app.qrRiderImage
      : 'assets/images/rider-me-qr.png';
    this.driverQrImg = this.envData.app.qrDriverImage
      ? this.baseurl + this.envData.app.qrDriverImage
      : 'assets/images/driver-me-qr.png';
  }

  getLink() {
    this._service.CommonGetApi("common/configuration/public?required[]=" + this.link).subscribe((data) => {
      this.item = data.data;
    });
  }

  downloadsection(value: any) {
    this.activeTab = value;
  }

  download(event: Event, platform) {
    event.preventDefault();
    const fullUrl = `${this.item?.productLinks?.[platform]}`;
    window.open(fullUrl, "_blank");
  }
}
